import { atom } from "recoil"

export const memberInvitationRequestIdState = atom({
  key: "atoms/organization/memberInvitationRequestIdState",
  default: 0,
})
